/**
 * CMS origins that may frame this site and drive the live preview.
 * Keep in sync with the "cms" CORS policy in Startup.cs.
 */
const ORIGINS = [
  'https://cms.teamfoster.nl',
  'https://beta.cms.teamfoster.nl',
  'https://cms.fstr.io',
  'https://cms5.fstr.io',
  'http://localhost:5000',
];

/**
 * Normalised to bare origins (scheme + host + port): a trailing "/" or path would never match
 * the browser's `MessageEvent.origin`, and the preview would silently ignore every CMS message.
 */
export const CMS_ORIGINS = ORIGINS.map(origin => new URL(origin).origin);
